import PropTypes from 'prop-types'
import styles from './text.module.scss'

const Text = ({ children, className = '', ...rest }) => {
  return (
    <div className={`${styles.text} ${className}`} {...rest}>
      {children}
    </div>
  )
}

Text.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  className: PropTypes.string,
}

export { Text }
